export function processUrl(url) {
  const details = new URL(url, window.location.origin)
  let normalized = null

  if (details.hash.length) {
    normalized = url.replace(details.hash, '')
  }

  return {
    hasHash: details.hash.length > 0,
    pathname: details.pathname,
    host: details.host,
    raw: url,
    href: normalized || details.href,
    hash: details.hash,
  }
}
